import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { getGraphQLClient } from '@/utils/graphqlClient'

import { SEARCH_ORDERS, SEARCH_USER_ORDERS } from './queries/searchOrders'

export interface OrderSearchResult {
  page?: number
  pageSize?: number
  totalCount?: number
  orders: ApiOrder[]
}

export interface OrderSearchApiResponse {
  searchOrders: OrderSearchResult
}

export interface OrderSearchInputType {
  searchParam: string
  page?: number
  pageSize?: number
}

export const useSearchOrdersApi = (
  authToken: string | null,
  input: OrderSearchInputType,
): UseQueryResult<OrderSearchResult, Error> => {
  const client = getGraphQLClient()

  const query = authToken ? SEARCH_USER_ORDERS : SEARCH_ORDERS
  const fetchOrders = async (): Promise<OrderSearchResult> => {
    const data = await client.request<OrderSearchApiResponse>(query, {
      input,
    })

    return data.searchOrders
  }
  return useQuery<OrderSearchResult>({
    queryKey: ['order-search', authToken || '', ...Object.values(input)],
    enabled: !!authToken || !!input?.searchParam,
    queryFn: fetchOrders,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useSearchUserOrdersApi = (
  input: OrderSearchInputType,
): UseQueryResult<OrderSearchResult, Error> => {
  const client = getGraphQLClient()

  const fetchOrders = async (): Promise<OrderSearchResult> => {
    const data = await client.request<OrderSearchApiResponse>(SEARCH_USER_ORDERS, {
      input,
    })

    return data.searchOrders
  }
  return useQuery<OrderSearchResult>({
    queryKey: ['order-search', ...Object.values(input)],
    enabled: !!input?.searchParam,
    queryFn: fetchOrders,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
